import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { treeSelectInjectionKey as p } from "../../tree-select/src/interface.js";
import { inject as A } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as N } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function I({
  props: a,
  fNodesRef: s,
  mergedExpandedKeysRef: c,
  mergedSelectedKeysRef: g,
  mergedCheckedKeysRef: w,
  handleCheck: b,
  handleSelect: k,
  handleSwitcherClick: u
}) {
  const {
    value: f
  } = g, v = A(p, null), t = v ? v.pendingNodeKeyRef : N(f.length ? f[f.length - 1] : null);
  function h(r) {
    var d;
    if (!a.keyboard)
      return {
        enterBehavior: null
      };
    const {
      value: o
    } = t;
    let i = null;
    if (o === null) {
      if ((r.key === "ArrowDown" || r.key === "ArrowUp") && r.preventDefault(), ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(r.key) && o === null) {
        const {
          value: n
        } = s;
        let e = 0;
        for (; e < n.length; ) {
          if (!n[e].disabled) {
            t.value = n[e].key;
            break;
          }
          e += 1;
        }
      }
    } else {
      const {
        value: n
      } = s;
      let e = n.findIndex((l) => l.key === o);
      if (!~e)
        return {
          enterBehavior: null
        };
      if (r.key === "Enter") {
        const l = n[e];
        switch (i = ((d = a.overrideDefaultNodeClickBehavior) === null || d === void 0 ? void 0 : d.call(a, {
          option: l.rawNode
        })) || null, i) {
          case "toggleCheck":
            b(l, !w.value.includes(l.key));
            break;
          case "toggleSelect":
            k(l);
            break;
          case "toggleExpand":
            u(l);
            break;
          case "none":
            break;
          case "default":
          default:
            i = "default", k(l);
        }
      } else if (r.key === "ArrowDown")
        for (r.preventDefault(), e += 1; e < n.length; ) {
          if (!n[e].disabled) {
            t.value = n[e].key;
            break;
          }
          e += 1;
        }
      else if (r.key === "ArrowUp")
        for (r.preventDefault(), e -= 1; e >= 0; ) {
          if (!n[e].disabled) {
            t.value = n[e].key;
            break;
          }
          e -= 1;
        }
      else if (r.key === "ArrowLeft") {
        const l = n[e];
        if (l.isLeaf || !c.value.includes(o)) {
          const y = l.getParent();
          y && (t.value = y.key);
        } else
          u(l);
      } else if (r.key === "ArrowRight") {
        const l = n[e];
        if (l.isLeaf)
          return {
            enterBehavior: null
          };
        if (!c.value.includes(o))
          u(l);
        else
          for (e += 1; e < n.length; ) {
            if (!n[e].disabled) {
              t.value = n[e].key;
              break;
            }
            e += 1;
          }
      }
    }
    return {
      enterBehavior: i
    };
  }
  return {
    pendingNodeKeyRef: t,
    handleKeydown: h
  };
}
export {
  I as useKeyboard
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/keyboard.js
// module id = 1762
// module chunks = 67